import React, {Fragment} from 'react';
import {useForm} from "react-hook-form";
import {getTranslated} from "../../utils/languageUtil";

const ProjectForm = () => {
    const {register, errors, handleSubmit} = useForm({
        mode: "onBlur"
    });
    const content = getTranslated('Product')['contactInfo']['projectForm'];
    const handleFormSubmission = (e) => {
        let formData = new FormData();
        for (const key in e ) {
            formData.append(key, e[key]);
        }
        fetch("https://getform.io/f/378104e4-b9fb-493e-acbc-71d2d2239718",{method:"POST", body:formData})
            .then(res => {
                document.forms[0].style.display = "none"
                document.getElementById("form-message").innerText = content["submitted"];
            });
    }

    return (
        <Fragment>
            <form  onSubmit={handleSubmit(handleFormSubmission)}>
                <div className="row mb-n4">
                    <div className="col-md-12 col-12 mb-4">
                        <input type="text" placeholder={content['name']} name="name"
                               ref={register({required: content['nameRequired']})}/>
                        {errors.name && <p>{errors.name.message}</p>}
                    </div>
                    <div className="col-md-12 col-12 mb-4">
                        <input type="email" placeholder="Email *" name="email" ref={register({
                            required: content['emailRequired'],
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: content['emailInvalid']
                            }
                        })}/>
                        {errors.email && <p>{errors.email.message}</p>}
                    </div>
                    <div className="col-12 mb-6">
                        <textarea name="message" placeholder={content['message']}
                                  ref={register({required: content['messageRequired']})}></textarea>
                        {errors.message && <p>{errors.message.message}</p>}
                    </div>
                    <div className="col-12 text-center mb-4">
                        <button type="submit" className="btn btn-primary btn-hover-secondary">{content['btnSubmit']}</button>
                    </div>
                </div>
            </form>
            <p className="form-message text-center" id="form-message"></p>
        </Fragment>
    )
}

export default ProjectForm;
